import type { FC } from 'react';

import { getStateValueStrings } from '@eneco/common/xstate/stateValue';
import { StackContainer } from '@eneco/custom-components/selfservice';
import useDC from '@eneco/dc/useDC';
import { Box, SkipToMain, PageGrid, Stack } from '@eneco/sparky';
import { BoxProps } from '@eneco/sparky/types';
import { DC_Repositories_Base_Enumerations_Label } from '@monorepo-types/dc';

import { Header } from '../Header/Header';
import { MeterReadingsRouter } from '../Router/Router';
import { useMeterReadingsFlow } from '../state/MeterReadingsFlow.machine';


const backgroundColors: Record<
  string,
  Partial<Record<DC_Repositories_Base_Enumerations_Label, BoxProps['backgroundColor']>>
> = {
  'THANK_YOU.Adhoc': {
    eneco: 'backgroundVarOne',
    oxxio: 'backgroundCMSVarThree',
  },
  'THANK_YOU.Tme': {
    eneco: 'backgroundVarOne',
    oxxio: 'backgroundCMSVarThree',
  },
  'THANK_YOU.PeriodicDelayed': {
    eneco: 'backgroundVarFour',
    oxxio: 'backgroundCMSVarOne',
  },
  'THANK_YOU.CloseDown': {
    eneco: 'backgroundVarFour',
    oxxio: 'backgroundCMSVarOne',
  },
  'THANK_YOU.Registration': {
    eneco: 'backgroundVarSix',
    oxxio: 'backgroundCMSVarThree',
  },
  THANK_YOU: {
    eneco: 'backgroundVarOne',
    oxxio: 'backgroundCMSVarOne',
  },
  ERROR_PAGE: {
    eneco: 'backgroundVarFour',
    oxxio: 'backgroundCMSVarOne',
  },
};

export const Layout: FC = () => {
  const { label } = useDC();
  const { state } = useMeterReadingsFlow();

  const stateValues = getStateValueStrings(state.value);

  const [_, backgroundColor] = Object.entries(backgroundColors).find(([key]) => stateValues.includes(key)) || [];
  const color = backgroundColor?.[label] || 'backgroundSecondary';

  const flowReachedFinalState = state.matches('THANK_YOU') || state.matches('ERROR_PAGE');

  return (
    <Box backgroundColor={color}>
      <StackContainer>
        <Box paddingBottom="10">
          <SkipToMain.SkipLink />
          {flowReachedFinalState ? (
            <SkipToMain.Main>
              <Header />
              <MeterReadingsRouter />
            </SkipToMain.Main>
          ) : (
            <SkipToMain.Main>
              <Stack gap="16">
                <Header />
                <Stack.Item>
                  <PageGrid>
                    <PageGrid.Item gridColumn={{ initial: '1/-1', md: '4/-1', lg: '4/10' }}>
                      <MeterReadingsRouter />
                    </PageGrid.Item>
                  </PageGrid>
                </Stack.Item>
              </Stack>
            </SkipToMain.Main>
          )}
        </Box>
      </StackContainer>
    </Box>
  );
};
